import classnames from 'classnames';

import type { Preference } from '@/types';

import { fieldGroupStyle, labelStyle } from './AdditionalFields.css';
import RadioOption from './RadioOption';

interface Props {
  preference: Preference;
}

const BooleanInputs = ({ preference }: Props) => {
  return (
    <fieldset className={classnames('flex flex-col gap-2', fieldGroupStyle)}>
      <legend className={classnames('w-full', labelStyle)}>
        {preference?.name}
        {preference?.required && <span>*</span>}
      </legend>
      <div>
        <RadioOption
          name={preference?.name_override || `field_${preference.custom_field_id}`}
          label="True"
          value="true"
          required={preference?.required}
        />
        <RadioOption
          name={preference?.name_override || `field_${preference?.custom_field_id}`}
          label="False"
          value="false"
        />
      </div>
    </fieldset>
  );
};

export default BooleanInputs;
